import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import CodeInfoSection from 'components/CodeInfoSection';
import Code from 'components/Code';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoPreliminaryClassificationCertificate extends Component {

    render() {
        const { preliminaryClassificationCertificate } = this.props;
        const summary = getTitleSummary(preliminaryClassificationCertificate)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Сборник принятых предварительных решений таможенных органов государств – членов Таможенного союза по классификации товаров'],
                    rows: summary
                }}
                expanded={(preliminaryClassificationCertificate.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Код',
                        'Страна',
                        'Описание',
                        'Обоснование принятия решения'
                    ],
                    rows: preliminaryClassificationCertificate.map(({ to_date = null, country = '', code = '', description = '', order }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        <Code code={code} />,
                        country,
                        description,
                        order
                    ]))
                }}
                sourceLink={this.preliminaryClassificationCertificateSourceLink}
            />);
    }
}

function getTitleSummary(items) {
    return items.length !== 0 ? [['есть']] : null;
}






// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoPreliminaryClassificationCertificate.js